export default "__VITE_ASSET__YuH7xD7C__"